import { Map } from 'immutable';
import { createSelector } from 'reselect';

export const getApp = (state) => state.get('app', Map());

export const getIsFetching = createSelector(
  getApp,
  app => app.get('isFetching', true)
);

export const getFingerprint = createSelector(
  getApp,
  app => app.get('contractinfo', '')
);

export const getHasProfile = createSelector(
  getApp,
  app => app.get('hasProfile', null)
);

export const getEmail = createSelector(
  getApp,
  app => app.get('email', '')
);

export const getMessage = createSelector(
  getApp,
  app => app.get('message', Map())
);
